import { Component } from '@theme/component';

class BbdProductInformation extends Component {
  #resizeObserver = new ResizeObserver(([entry]) => {
    if (!entry) return;

    const { top } = entry.target.getBoundingClientRect();
    const heightToTop = top + document.documentElement.scrollTop;
    entry.target.style.setProperty('--height-to-top', `${heightToTop}px`);
  });

  connectedCallback() {
    super.connectedCallback();
    this.#resizeObserver.observe(this);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#resizeObserver.disconnect();
  }
}

if (!customElements.get('bbd-product-information')) {
  customElements.define('bbd-product-information', BbdProductInformation);
}
